import AccessRequest from "@/views/accessRequest/AccessRequest.vue";
import type { RouterOptions } from "vue-router";

// Troubleshoot your routes using this - https://paths.esm.dev

const names = {
  distributor: "AccessRequest.Distributor",
};

export { names as accessRequestRouteNames };

const accessRequestRoutes: RouterOptions["routes"] = [
  {
    path: "/distributor-access-request",
    name: names.distributor,
    meta: { title: "Distributor Access Request New", isNew: true },
    component: {
      render: () => <AccessRequest entityLabel="Distributor" entityName="Distributor" />,
    },
  },
];
export default accessRequestRoutes;
